import React, { memo } from 'react';
import { Icon, Tooltip } from 'antd';
import { RatingContainer } from '../styles';
import { MAX_LEAD_RATE } from '../../../constants';

const STARS = Array.from({ length: MAX_LEAD_RATE });

export const LeadRating = memo(({ rate, description }) => {
  const value = Number(rate);
  // Fora da escala 1..3 é dado legado inválido, não classificação
  if (!(value >= 1 && value <= MAX_LEAD_RATE)) return null;

  // O tooltip carrega o texto de Observações para não obrigar a abrir o
  // drawer só para ler a anotação do lead
  const title = (
    <span>
      <strong>Potencial: {value}/{MAX_LEAD_RATE}</strong>
      {description && (
        <span style={{ display: 'block', marginTop: 4, whiteSpace: 'pre-wrap' }}>
          {description}
        </span>
      )}
    </span>
  );

  return (
    <Tooltip title={title} overlayStyle={{ maxWidth: 320 }}>
      <RatingContainer>
        {STARS.map((_, index) => (
          <Icon
            key={index}
            type="star"
            theme="filled"
            style={{ color: index < value ? '#fadb14' : '#d9d9d9' }}
          />
        ))}
      </RatingContainer>
    </Tooltip>
  );
});

LeadRating.displayName = 'LeadRating';
